export const FOLLOW_UP_ALERTS_REFRESH_EVENT = 'followUpAlerts:refresh';

export const notifyFollowUpAlertsChanged = () => {
	if (typeof window !== 'undefined') {
		window.dispatchEvent(new CustomEvent(FOLLOW_UP_ALERTS_REFRESH_EVENT));
	}
};
